import Phaser from 'phaser';
import { GAME_CONFIG, COLORS } from './config';
import { BootScene } from './scenes/BootScene';
import { MenuScene } from './scenes/MenuScene';
import { GameScene } from './scenes/GameScene';

/**
 * Cosmic Cadet - A Commander Keen-style platformer
 * Built with Phaser 3 + Cloudflare Pages/Workers
 */

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: GAME_CONFIG.WIDTH,
  height: GAME_CONFIG.HEIGHT,
  parent: 'game-container',
  backgroundColor: COLORS.SKY,
  pixelArt: true,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    zoom: GAME_CONFIG.SCALE,
  },
  physics: {
    // We use our own physics, but Phaser needs this to avoid warnings
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [BootScene, MenuScene, GameScene],
};

// Create game instance
const game = new Phaser.Game(config);

// Handle window focus/blur
window.addEventListener('blur', () => {
  game.scene.scenes.forEach(scene => {
    if (scene.scene.isActive()) {
      scene.scene.pause();
    }
  });
});

window.addEventListener('focus', () => {
  game.scene.scenes.forEach(scene => {
    if (scene.scene.isPaused()) {
      scene.scene.resume();
    }
  });
});

console.log('Cosmic Cadet initialized');
console.log('Controls: Arrow Keys/WASD to move, Space to jump, Shift for pogo');
